import { i18n } from '../../utils/GadgetUtils';

export const ACTIONS = {
    ALL_SIGNIN_SUCCESS: 'allSignInSucess',
    ALL_SIGNIN_FAILED: 'allSignInFailed',
    PARTIAL_SIGNIN: 'partialSignIn',
    ALL_RETRY_SIGNIN_FAILED: 'allRetrySignInFailed',
    RETRY_PARTIAL_SIGNIN: 'retryPartialSignIn',
    AGENT_UNAVAILABILITY_PARTIAL_READY: 'partialReadyDueToAgentUnavailability',
    AGENT_UNAVAILABILITY_ALL_NOT_READY: 'AllNotReadyDueToAgentUnavailability',
    STATE_CHANGE_FAILED: 'stateChangeFailed'

};

export const ImiDesktopNotificationManager = (function () {
    function showNotification (actionType, label, channelNames) {
        console.log(`Finesse-IMI Gadget: IMIDesktopNotification showNotification- `, actionType, label, channelNames);

        if (!(actionType && label)) {
            return;
        }

        const notificationProps = {
            messageFrom: '',
            message: '',
            isDismissable: true,
            timeout: 8000,
            icon: {name: 'circle', size: 24},
            pristine: true
        }

        switch (actionType) {
            case ACTIONS.ALL_SIGNIN_SUCCESS:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.allSignInSuccess.title', label);
                notificationProps.message = i18n.getMsg('gadget.imi.desktopNotification.allSignInSuccess.desc');
                notificationProps.icon.name = 'mui-success-tick-circle';
                break;
            case ACTIONS.ALL_SIGNIN_FAILED:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.allSignInFailed.title', label);
                notificationProps.message = i18n.getString('gadget.imi.desktopNotification.allSignInFailed.desc', label);
                notificationProps.icon.name = 'mui-warning';
                break;
            case ACTIONS.PARTIAL_SIGNIN:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.partialSignIn.title', label);
                notificationProps.message = i18n.getString('gadget.imi.desktopNotification.partialSignIn.desc', channelNames);
                notificationProps.icon.name = 'mui-warning';
                break;
            case ACTIONS.ALL_RETRY_SIGNIN_FAILED:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.allRetrySignInFailed.title', label);
                notificationProps.message = i18n.getString('gadget.imi.desktopNotification.allRetrySignInFailed.desc', label);
                notificationProps.icon.name = 'mui-warning';
                break;
            case ACTIONS.RETRY_PARTIAL_SIGNIN:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.retryPartialSignIn.title', label);
                notificationProps.message = i18n.getString('gadget.imi.desktopNotification.retryPartialSignIn.desc', channelNames);
                notificationProps.icon.name = 'mui-warning';
                break;
            case ACTIONS.AGENT_UNAVAILABILITY_PARTIAL_READY:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.partialReadyDueToAgentUnavailability.title', label);
                notificationProps.message = i18n.getString('gadget.imi.desktopNotification.partialReadyDueToAgentUnavailability.desc', channelNames);
                notificationProps.icon.name = 'mui-warning';
                break;
            case ACTIONS.AGENT_UNAVAILABILITY_ALL_NOT_READY:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.AllNotReadyDueToAgentUnavailability.title', label);
                notificationProps.message = i18n.getMsg('gadget.imi.desktopNotification.AllNotReadyDueToAgentUnavailability.desc');
                notificationProps.icon.name = 'mui-warning';
                break;
            case ACTIONS.STATE_CHANGE_FAILED:
                notificationProps.messageFrom = i18n.getString('gadget.imi.desktopNotification.stateChangeFailed.title', label);
                notificationProps.message = i18n.getString('gadget.imi.desktopNotification.stateChangeFailed.desc', channelNames);
                notificationProps.icon.name = 'mui-warning';
                break;
        }
        console.log(`Finesse-IMI Gadget: IMIDesktopNotification showNotification2- `, notificationProps);

        window.finesse.containerservices.ContainerServices.showMyGadgetNotification({...notificationProps});
    }

    return {
        showNotification
    }
})();
